<template>
  <div class="flex items-start mb-2">
    <div class="flex items-center h-5">
      <input
        v-bind="$attrs"
        :id="id"
        v-model="proxyChecked"
        type="checkbox"
        class="focus:ring-alo-800 h-4 w-4 text-alo-200 border-gray-300 rounded"
        :class="{ 'with-errors': error }"
      />
    </div>
    <div class="ml-3 text-sm">
      <label :for="id" class="font-medium text-gray-700">
        <slot />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  model: {
    prop: 'modelValue',
    event: 'change',
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: () => 'checkbox-' + Math.floor(Math.random() * 100000),
    },
    error: {
      type: Object,
      default: null,
    },
  },

  computed: {
    proxyChecked: {
      get() {
        return this.modelValue
      },

      set(value) {
        this.$emit('change', value)
      },
    },
  },
}
</script>
